import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className, hover = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={hover ? { y: -4 } : undefined}
      className={clsx(
        'bg-white rounded-xl shadow-sm border border-gray-100',
        'overflow-hidden', // Prevent content overflow on mobile
        'w-full', // Full width on mobile
        'touch-manipulation', // Better touch handling
        hover && 'transition-all duration-200 hover:shadow-lg hover:border-emerald-100',
        className
      )}
    >
      {children}
    </motion.div>
  );
};